export default __webpack_public_path__ + "static/media/twitter.c602d156.png";